export default __webpack_public_path__ + "static/media/VirtualSpace.57738431.mp3";